import React from 'react'
import NextHead from 'next/head'
import { useRouter } from 'next/router'
import clsx from 'clsx'

// Toggles
import {
  IS_HOMEPAGE_BANNERS_ENABLED,
  IS_CONTENT_SEARCH_ENABLED,
  IS_DOCUMENT_COLLECTION_ENABLED,
} from 'configs/toggle'
// General Components
import Header from 'app/Homepage/components/Header'
import NavigationBar from 'app/Homepage/components/NavigationBar'
// Features Components
import Banners from 'app/Homepage/components/Banners'
import { KSSelectionCard } from 'app/Homepage/components/KSSelectionCard'
import PendaftaranIKM from 'app/Homepage/components/PendaftaranIKM'
import Products from 'app/Homepage/components/Products'
import ContentCollection from 'app/Homepage/components/ContentCollection'
import TentangKurikulumMerdeka from 'app/Homepage/components/TentangKurikulumMerdeka'
import DocumentCollectionEntryPoint from 'app/Homepage/components/DocumentCollectionEntryPoint'
import SearchBar from 'app/Homepage/components/SearchBar'
import ConversationEntryPoint from 'app/Homepage/components/ConversationEntryPoint'
import ConversationOnboarding from 'app/Homepage/components/ConversationOnboarding'

interface IHomepageProps {
  isInfoTerkiniEnabled: boolean
  currentDateTimeServer: string
  isKinerjaEntryPointEnabled: boolean
  isGuruAIEligible: boolean
}
const Homepage = ({
  isInfoTerkiniEnabled,
  currentDateTimeServer,
  isKinerjaEntryPointEnabled,
  isGuruAIEligible,
}: IHomepageProps) => {
  const router = useRouter()
  const containerClassName = clsx(
    'bg-gray-5 text-type-basic-dark scroll-smooth pb-14 min-h-[calc(100vh-56px)]',
    !IS_CONTENT_SEARCH_ENABLED && 'mt-14'
  )

  React.useEffect(() => {
    if (IS_CONTENT_SEARCH_ENABLED) {
      router.prefetch('/pencarian')
    }
  }, [router])

  return (
    <>
      {/* eslint-disable react/no-unknown-property */}
      <style jsx global>
        {`
          .entry-point-section:empty {
            padding: 0 !important;
          }
        `}
      </style>
      <NextHead>
        <title>Beranda - Merdeka Mengajar</title>
        <meta
          name="description"
          content="Temukan beragam bahan ajar, buku teks, modul ajar, paket soal asesmen, serta program pelatihan untuk mendukung guru melakukan pembelajaran yang merdeka."
        />
      </NextHead>

      <Header
        data-testid="home-header-v2"
        showUserProfile={false}
        useHeaderV2
        className={clsx(IS_CONTENT_SEARCH_ENABLED && '!relative h-12 pt-2')}
      />

      <div className={containerClassName}>
        {/* Search Bar */}
        {IS_CONTENT_SEARCH_ENABLED && <SearchBar />}

        {/* Homepage Banners */}
        {IS_HOMEPAGE_BANNERS_ENABLED && <Banners className="pt-4 bg-white" />}

        {/* Conversation Entry Point */}
        {isGuruAIEligible && <ConversationEntryPoint />}

        <div className="p-4 space-y-4 entry-point-section bg-gray-5">
          {/* Seleksi Kepala Sekolah Entry Point */}
          <KSSelectionCard />

          {/* IKM Entry Point */}
          <PendaftaranIKM />
        </div>

        <div className="relative py-3 mb-6 space-y-5 bg-white">
          {/* Products */}
          <Products
            currentDateTimeServer={currentDateTimeServer}
            isKinerjaEntryPointEnabled={isKinerjaEntryPointEnabled}
          />
        </div>

        {/* Content Collection */}
        <ContentCollection />

        {/* Tentang KM Card */}
        {IS_DOCUMENT_COLLECTION_ENABLED ? (
          <DocumentCollectionEntryPoint />
        ) : (
          <TentangKurikulumMerdeka />
        )}
      </div>

      {/* Conversation Onboarding */}
      {isGuruAIEligible && <ConversationOnboarding />}

      <NavigationBar isInfoTerkiniEnabled={isInfoTerkiniEnabled} />
    </>
  )
}

export default Homepage
